import { b as o, g as e } from "../packages/utils/dist/useIntersectionObserver-1ee6520e.mjs";
import "react";
class h {
  constructor() {
    this._notScrollStyleSheet = document.createElement("style");
    const t = o();
    this._notScrollStyleSheet.innerText = `html { overflow-y: hidden;padding-right: ${t}px !important;}`;
  }
  append() {
    const t = e().document.head;
    t.contains(this._notScrollStyleSheet) || t.appendChild(this._notScrollStyleSheet);
  }
  remove() {
    const t = e().document.head;
    t.contains(this._notScrollStyleSheet) && t.removeChild(this._notScrollStyleSheet);
  }
}
export {
  h as CreateNotScrollStyle
};
//# sourceMappingURL=createNotScrollStyle.mjs.map
